import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Settings() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [open, setOpen] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [clearText, setClearText] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  function onFileUpload() {
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);
    var profilPicName = state.auth.user.user_id + makeid(5) + ".jpg";
    formData.append("user_id", state.auth.user.user_id);
    formData.append("user_image", profilPicName); // Details of the uploaded file
    console.log(selectedFile);

    // Request made to the backend api
    // Send formData object

    const config = {
      headers: {
        Authorization: state.auth.token,

        // "Content-Type": "application/json",
      },
    };
    var time = new Date();

    axios
      .post(API_URL + "/upload_profile_picture", formData, config)
      .then(() => {
        window.location.reload();
      });

    document.getElementById("contained-button-file").value = "";
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
  }

  function onFileClick(event) {
    document.getElementById("contained-button-file").value = "";
  }

  const [selectedFile, setSelectedFile] = useState("");
  useEffect(() => {
    if (selectedFile) {
      onFileUpload();
    }
  }, [selectedFile]);

  function changePassword() {
    if (
      confirmPassword.length == 0 ||
      newPassword.length == 0 ||
      currentPassword.length == 0
    ) {
      createAlert("ERROR", "Error", "Check all fields carefully.");
    } else if (confirmPassword != newPassword) {
      createAlert("ERROR", "Error", "Confirm password does not match.");
    } else if (confirmPassword.length < 8) {
      createAlert("ERROR", "Error", "Password must be at least 8 characters.");
    } else {
      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,
          "Content-Type": "application/json",
        },
      };

      body["user_id"] = state.auth.user.user_id;
      body["current_password"] = currentPassword;
      body["new_password"] = newPassword;
      body = JSON.stringify(body);
      axios
        .post(API_URL + "/change_user_password", body, config)
        .then((res) => {
          createAlert("SUCCESS", "Success", "Password updated.");
          window.location.reload();
        })
        .catch((err) => {
          createAlert(
            "ERROR",
            "Error",
            "Current password is wrong. If you dont remember your current password, please use the Forgot Password button in Login page."
          );
        });
    }
  }

  function changePhoneNumber() {
    if (
      phoneNumber.length == 0 ||
      (phoneNumber.length > 15 && /\D/.test(phoneNumber))
    ) {
      createAlert("ERROR", "Error", "Enter valid phone number.");
    } else {
      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };

      body["user_id"] = state.auth.user.user_id;
      body["phone_number"] = phoneNumber;
      body = JSON.stringify(body);
      axios.post(API_URL + "/change_phone_number", body, config).then((res) => {
        createAlert("SUCCESS", "Success", "Phone Number updated.");
      });
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_student) {
        return (
          <Fragment>
            <Sidebar />

            <div
              style={{
                margin: "58px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              <Grid container spacing={10}>
                <Grid item md={6}>
                  <h2>PERSONAL DETAILS</h2>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <h3>
                        {" " +
                          state.auth.user.class_id +
                          " " +
                          state.auth.user.division}
                      </h3>
                      <span>
                        Name :<b>{state.auth.user.full_name}</b>
                      </span>
                    </span>
                    <input
                      id="contained-button-file"
                      style={{
                        display: "none",
                        height: "150px",
                        cursor: "pointer",
                        width: "150px",
                      }}
                      type="file"
                      onChange={(e) => onFileChange(e)}
                      onClick={(e) => onFileClick(e)}
                    />
                    <label
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      htmlFor="contained-button-file"
                    >
                      <Avatar
                        style={{
                          height: "150px",
                          width: "150px",
                          marginTop: "-50px",
                          cursor: "pointer",
                        }}
                        alt={state.auth.user.full_name}
                        src={API_URL + "/media/" + state.auth.user.user_image}
                      />
                      <h5 style={{ textAlign: "center", marginTop: "5px" }}>
                        UPLOAD PHOTO
                      </h5>
                    </label>
                  </div>
                  <br></br>
                  <br></br>
                  <span>
                    Email : <b>{state.auth.user.email}</b>
                  </span>{" "}
                  <br></br>
                  <span>
                    Phone Number : <b>{state.auth.user.phone_number}</b>
                  </span>
                  <br></br>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <TextField
                      style={{ marginTop: "10px" }}
                      fullWidth
                      size="small"
                      placeholder="Phone Number"
                      variant="outlined"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                    <Button
                      style={{
                        fontSize: "15px",
                        height: "40px",
                        marginTop: "10px",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        changePhoneNumber();
                      }}
                      variant="contained"
                    >
                      <h5>Change</h5>
                    </Button>
                  </div>{" "}
                  <br />
                  <br />
                  <span>Change Password:</span>
                  <br></br>
                  <TextField
                    style={{ backgroundColor: "white", borderRadius: "6px" }}
                    variant="outlined"
                    required
                    fullWidth
                    name="password"
                    margin="normal"
                    autoComplete="new-password"
                    placeholder="Current Password"
                    type={clearText ? "text" : "password"}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          size="small"
                          style={{ marginRight: "-8px", paddingLeft: "10px" }}
                          onClick={() => setClearText(!clearText)}
                        >
                          {clearText ? (
                            <VisibilityOffIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          ) : (
                            <VisibilityIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          )}
                        </IconButton>
                      ),
                    }}
                  />
                  <br />
                  <TextField
                    style={{ backgroundColor: "white", borderRadius: "6px" }}
                    variant="outlined"
                    required
                    fullWidth
                    name="password"
                    margin="normal"
                    placeholder="New Password"
                    type={clearText ? "text" : "password"}
                    value={newPassword}
                    autoComplete="new-password"
                    onChange={(e) => setNewPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          size="small"
                          style={{ marginRight: "-8px", paddingLeft: "10px" }}
                          onClick={() => setClearText(!clearText)}
                        >
                          {clearText ? (
                            <VisibilityOffIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          ) : (
                            <VisibilityIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          )}
                        </IconButton>
                      ),
                    }}
                  />
                  <br />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <TextField
                      style={{ backgroundColor: "white", borderRadius: "6px" }}
                      variant="outlined"
                      required
                      fullWidth
                      name="password"
                      margin="normal"
                      autoComplete="new-password"
                      placeholder="Confirm New Password"
                      type={clearText ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            size="small"
                            style={{ marginRight: "-8px", paddingLeft: "10px" }}
                            onClick={() => setClearText(!clearText)}
                          >
                            {clearText ? (
                              <VisibilityOffIcon
                                style={{ color: themeStyle.primaryColor }}
                              />
                            ) : (
                              <VisibilityIcon
                                style={{ color: themeStyle.primaryColor }}
                              />
                            )}
                          </IconButton>
                        ),
                      }}
                    />
                    <Button
                      style={{
                        fontSize: "15px",
                        height: "50px",
                        marginTop: "18px",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        changePassword();
                      }}
                      variant="contained"
                    >
                      <h5>Change</h5>
                    </Button>
                  </div>
                </Grid>
                <Grid item md={6}>
                  <div>
                    <h2>PARENTS DETAILS</h2>
                    {JSON.parse(state.auth.user.parent_email_list).map(
                      (parent, index) => (
                        <Fragment>
                          <span>
                            <b>Name: </b>
                            {parent["name"]}
                          </span>
                          <br></br>
                          <span>
                            <b>Email: </b>
                            {parent["email"]}
                          </span>
                          <br></br>
                          <br></br>
                        </Fragment>
                      )
                    )}
                  </div>
                  <br></br>
                  <br></br>
                </Grid>
              </Grid>
            </div>
          </Fragment>
        );
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Settings;
